import {instance,fileDownload2} from '@/Utils/axios'

export default {
  // 任务列表
  getPigList: params => instance.post('/sat-collect/nhfManager/listByLine', params), // 猪线路列表
  pigDetail: params => instance.post('/sat-collect/history/detail', params), // 猪线路详情
  exportExcel: params => fileDownload2("/sat-collect/nhfManager/exportExcel", params), // 猪线路详情

  // getRuminateList: params => instance.post('/sat-collect/nhfManager/listByLine', params), // 反刍线路列表
  // ruminateDetail: params => instance.post('/sat-collect/history/detail', params), // 反刍线路详情
  
  deptList: () => instance.get('/sat-collect/nhfManager/dept'), // 猪线路详情
  deptTree: () => instance.get('/iot-system/dept/tree'), // 组织树
  getFileUrlList: params => instance.get('/sat-collect/upload/getFileUrlList',{params}), // 猪线路详情

  // 图表分析
  mineOverview: params => instance.get('/sat-collect/pigLine/analysis/mine/overview', {params}), // 我的概况
  mineRank: params => instance.get('/sat-collect/pigLine/analysis/mine/rank', {params}), // 实证排名
  analysisWeightCost: params => instance.get('/sat-collect/pigLine/analysis/weightCost', {params}), // 料肉比（FCR）分析
  mealProductCost: params => instance.get('/sat-collect/pigLine/analysis/mealProductCost', {params}), // 造肉成本分析
  settlementRank: params => instance.get('/sat-collect/pigLine/analysis/settlementRank', {params}), // 片区提交数据排名
  settlementDetail: params => instance.get(`/sat-collect/pigLine/analysis/settlement/${params.settlementId}/detail`, {params}), // 片区详情


};